import React from 'react';

interface DataRow {
    title: string;
    value: string;
    isAllowCopy: boolean
}

interface InfoSectionProps {
    className?: string;
    title: string;
    rows: DataRow[];
    HeaderIcon: React.ComponentType<{ size?: number; className?: string }>;
    CopyIcon: React.ComponentType<{ className?: string }>;
    Text: React.ComponentType<{
        as?: string;
        weight?: string;
        className?: string;
        children: React.ReactNode
    }>;
    containerBgClass?: string;
    titleTextClass?: string;
    valueTextClass?: string;
    borderClass?: string;
    contentBgClass?: string;
}

export const renderRow = (
    title: string,
    value: string | undefined,
    isAllowCopy: boolean,
    Text: React.ComponentType<{
        as?: string;
        weight?: string;
        className?: string;
        children: React.ReactNode
    }>,
    CopyIcon: React.ComponentType<{ className?: string }>,
    titleTextClass: string = 'text-[14px] text-aloix-black',
    valueTextClass: string = 'text-[14px] text-aloix-grey',
    borderClass: string = 'border-separator'
) => {
    const copyToClipboard = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };

    return (
        <div>
            <Text as="span" weight='medium' className={`${titleTextClass}`}>{title}</Text>
            <div className={`flex items-center justify-between border-b ${borderClass} pb-3`}>
                <Text as="span" weight='normal' className={`${valueTextClass}`}>{value}</Text>
                {isAllowCopy && value && value.trim() && (
                    <button
                        onClick={() => copyToClipboard(value)}
                        className="p-1 hover:bg-gray-200 rounded transition-colors"
                    >
                        <CopyIcon className="w-4 h-4 text-aloix-grey" />
                    </button>
                )}
            </div>
        </div>
    );
};

const InfoSection: React.FC<InfoSectionProps> = ({
    className = '',
    title,
    rows,
    HeaderIcon,
    CopyIcon,
    Text,
    containerBgClass = 'bg-header',
    titleTextClass = 'text-[14px] text-aloix-black',
    valueTextClass = 'text-[14px] text-aloix-grey',
    borderClass = 'border-separator',
    contentBgClass = 'bg-white'
}) => {

    return (
        <div className={`${containerBgClass} rounded-t-lg ${className}`}>
            <div className="flex items-center gap-2 mx-4 my-4">
                <HeaderIcon size={20} className="text-aloix-grey" />
                <Text as="span" weight='medium' className={`${titleTextClass} whitespace-pre-line`}>
                    {title}
                </Text>
            </div>
            <div className={`${contentBgClass} rounded-lg border ${borderClass} p-6`}>
                <div className="space-y-4">
                    {rows.map((row, index) =>
                        <div key={index}>
                            {renderRow(row.title, row.value, row.isAllowCopy, Text, CopyIcon, titleTextClass, valueTextClass, borderClass)}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default InfoSection;